// Mandate approval redirects must stay on Mangopay's own domain - a bare
// startsWith("https://") check would let a compromised/misconfigured backend
// send the user to any https host (open redirect).
export var isTrustedMandateRedirectUrl = function (url) {
    if (!url) {
        return false;
    }
    try {
        var _a = new URL(url), protocol = _a.protocol, hostname = _a.hostname;
        return (protocol === "https:" &&
            (hostname === "mangopay.com" || hostname.endsWith(".mangopay.com")));
    }
    catch (_b) {
        return false;
    }
};
